export default __webpack_public_path__ + "static/media/instagram-logo.cf56780f.svg";